import React from "react";
import Form from "repoV2/components/common/Form/Form/Form";
import { ICheckoutFormProps } from "./CheckoutForm.interfaces";
import { useCheckoutForm } from "./CheckoutForm.utils";

const CheckoutForm = ({ children }: ICheckoutFormProps) => {
    const { handleSubmit, handleError, defaultValues } = useCheckoutForm();

    return (
        <Form
            onSubmit={handleSubmit}
            onError={handleError}
            mode="onSubmit"
            reValidateMode="onChange"
            defaultValues={defaultValues}
            // We set autoComplete at form level, and will be providing specific autoComplete
            // values to the input level
            // Reason: When pages is cached or user returns from browser back button, then form is
            // auto filled for props like name and email. However react-hook-form states are not auto updated in
            // such cases, so we set autoComplete to 'off' to give a good 'ui' experience to user
            autoComplete="off"
        >
            {children}
        </Form>
    );
};

export default CheckoutForm;
